module.exports = __webpack_public_path__ + "img/Inspirational Motivator.9b8fdf25.svg";